import { Redirect, Switch } from "react-router-dom";

import { SimpleRoute } from "app/AppRoute";
import { DownloadDesktop } from "app/account/Download/DownloadDesktop";
import { ActiveDirectoryLogin } from "app/account/LogIn/ActiveDirectoryLogin/ActiveDirectoryLogin";
import { LoginComponent } from "app/account/LogIn/LogInComponent";
import { OrgLogin } from "app/account/LogIn/OrganisationsLogin/OrgLogin";
import { RecordViewLogin } from "app/account/LogIn/RecordViewLogin/RecordViewLogin";
import { ProductLoginRoutesSection } from "app/account/ProductLoginRoutesSection";
import { UNAUTHED_ROUTES } from "shared/Routes";

/**
 * A group of React Router routes that unauthenticated users can access,
 * plus redirects for unauthenticated routes.
 */
export const UnauthedRoutes = () => {
    return (
        <Switch>
            <SimpleRoute
                path={UNAUTHED_ROUTES.loginOrganisations}
                component={OrgLogin}
                exact
            />
            <SimpleRoute
                path={UNAUTHED_ROUTES.loginRecordView}
                component={RecordViewLogin}
                exact
            />
            <SimpleRoute
                path={UNAUTHED_ROUTES.loginActiveDirectory}
                component={ActiveDirectoryLogin}
                exact
            />
            <SimpleRoute
                path={UNAUTHED_ROUTES.downloadDesktop}
                component={DownloadDesktop}
                exact
            />

            <SimpleRoute
                path={UNAUTHED_ROUTES.login}
                component={LoginComponent}
                exact
            />
            <SimpleRoute
                path={[
                    UNAUTHED_ROUTES.forgotPassword,
                    UNAUTHED_ROUTES.resetPassword,
                    UNAUTHED_ROUTES.resetPasswordConfirm,
                    UNAUTHED_ROUTES.register,
                    UNAUTHED_ROUTES.confirmEmailVerify,
                ]}
                component={ProductLoginRoutesSection}
                exact
            />

            <Redirect from="*" to={UNAUTHED_ROUTES.login} />
        </Switch>
    );
};
